import { NavLink, Outlet } from "react-router-dom";
import { AlertIcon, BookIcon, BookmarkIcon, CompassIcon, MapIcon, SearchIcon } from "./Icons";
import { AuthorDialog } from "./AuthorDialog";

const primary = [
  ["/map", "人生地图", MapIcon], ["/events", "遇事查找", CompassIcon], ["/library", "完整原书", BookIcon], ["/saved", "我的收藏", BookmarkIcon]
] as const;
export function Layout() {
  return <div className="app-shell">
    <header className="site-header">
      <NavLink to="/map" className="brand" aria-label="人生地图首页"><span className="brand-mark">人</span><span><b>人生地图</b><small>高性价比人生指南</small></span></NavLink>
      <nav className="desktop-nav" aria-label="主导航">{primary.map(([to, label]) => <NavLink key={to} to={to}>{label}</NavLink>)}</nav>
      <div className="header-actions"><AuthorDialog/><NavLink className="header-text-button" to="/download">下载</NavLink><NavLink className="emergency-link" to="/emergency"><AlertIcon/>紧急情况</NavLink><NavLink className="icon-link" to="/search" aria-label="全文搜索"><SearchIcon/></NavLink></div>
    </header>
    <main id="main" tabIndex={-1}><Outlet/></main>
    <footer className="site-footer"><p>内容来源：《高性价比人生指南》，eternity4719 及原项目贡献者 · <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank" rel="noreferrer">CC BY 4.0</a></p><nav aria-label="页脚导航"><NavLink to="/documents">资料库</NavLink><NavLink to="/download">下载原书</NavLink><NavLink to="/about">来源与许可</NavLink><NavLink to="/changes">版本变更</NavLink></nav></footer>
    <nav className="mobile-nav" aria-label="移动端主导航">{primary.map(([to, label, Icon]) => <NavLink key={to} to={to}><Icon/><span>{label.replace("完整", "")}</span></NavLink>)}</nav>
  </div>;
}
